"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcTransactionConfirmationBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_transaction_confirmation_constants_1 = require("./bc-transaction-confirmation-constants");
var bc_transaction_status_constants_1 = require("../../atoms/bc-transaction-status/bc-transaction-status-constants");
var bc_tooltip_behavior_1 = require("../../molecules/bc-tooltip/bc-tooltip-behavior");
var bc_link_constants_1 = require("../../atoms/bc-link/bc-link-constants");
var BcTransactionConfirmationBehavior = (function (_super) {
    __extends(BcTransactionConfirmationBehavior, _super);
    function BcTransactionConfirmationBehavior() {
        var _this = _super.call(this) || this;
        _this.transactionStatusType = {
            success: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SUCCESS,
            error: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_ERROR,
            warning: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_WARNING,
            info: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_INFO,
            generic: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_GENERIC,
            dynamic: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_DYNAMIC
        };
        _this.transactionStatusSize = {
            '2xs': bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_2XS,
            sm: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_SM,
            md: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_MD,
            lg: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_LG,
            xl: bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_SIZE_XL
        };
        _this.linkTypes = {
            default: bc_link_constants_1.BcLinkConstants.LINK_DEFAULT,
            small: bc_link_constants_1.BcLinkConstants.LINK_SMALL,
            large: bc_link_constants_1.BcLinkConstants.LINK_LARGE,
            underline: bc_link_constants_1.BcLinkConstants.LINK_UNDERLINE,
            underlineDefault: bc_link_constants_1.BcLinkConstants.LINK_UNDERLINE_DEFAULT,
            underlineSmall: bc_link_constants_1.BcLinkConstants.LINK_UNDERLINE_SMALL,
            underlineLarge: bc_link_constants_1.BcLinkConstants.LINK_UNDERLINE_LARGE,
        };
        _this.iconSize = {
            xs: common_constants_1.BcCommonConstants.ICON_XS_CLASS,
            sm: common_constants_1.BcCommonConstants.ICON_SM_CLASS,
            md: common_constants_1.BcCommonConstants.ICON_MD_CLASS,
            lg: common_constants_1.BcCommonConstants.ICON_LG_CLASS,
            xl: common_constants_1.BcCommonConstants.ICON_XL_CLASS,
            '2xl': common_constants_1.BcCommonConstants.ICON_2XL_CLASS,
            '3xl': common_constants_1.BcCommonConstants.ICON_3XL_CLASS,
        };
        return _this;
    }
    BcTransactionConfirmationBehavior.prototype._setUp = function () {
        _super.prototype._setUp.call(this);
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
    };
    BcTransactionConfirmationBehavior.prototype.setItemsTransaction = function (items) {
        this.insertNodeChildrensTransactionConfirmation(items);
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionStatus = function (itemsConfig) {
        var transactionStatusType = this.transactionStatusType[itemsConfig.status];
        var transactionStatusSize = this.transactionStatusSize[itemsConfig.size];
        var transactionStatusIcon = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_ICON_CLASS],
            innerText: itemsConfig.icon
        });
        var transactionStatus = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_status_constants_1.BcTransactionStatusConstants.BC_TRANSACTION_STATUS_CLASS, transactionStatusType, transactionStatusSize],
            children: [transactionStatusIcon]
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_STATUS_CLASS],
            children: [transactionStatus]
        });
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionConfirmationVoucher = function (itemsData) {
        var vocherNumber = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SPAN_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_VOUCHER_NUMBER_CLASS],
            innerText: itemsData.number
        });
        var voucherTitle = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_VOUCHER_TITLE_CLASS],
            innerText: itemsData.title,
            children: [vocherNumber]
        });
        var voucherDate = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_VOUCHER_DATE_CLASS],
            innerText: itemsData.date
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_VOUCHER_CLASS],
            children: [voucherTitle, voucherDate]
        });
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionConfirmationMessage = function (items) {
        var titleMessage = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.H1_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_TITLE_TITLE_CLASS],
            innerText: items.title
        });
        var messageSupport = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.H2_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_TITLE_SUBTITLE_CLASS],
            innerText: items.supportMessage
        });
        var headerTitleTransaction = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_TITLE_CLASS],
            children: []
        });
        if (items.title) {
            headerTitleTransaction.appendChild(titleMessage);
        }
        if (items.supportMessage) {
            headerTitleTransaction.appendChild(messageSupport);
        }
        var voucherData = items.voucher ? this.createTransactionConfirmationVoucher(items.voucher) : [];
        var transactionConfirmationMessage = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_HEADER_CLASS],
            children: [headerTitleTransaction, voucherData]
        });
        transactionConfirmationMessage.setAttribute('id', items.id);
        return transactionConfirmationMessage;
    };
    BcTransactionConfirmationBehavior.prototype.createTooltipIcon = function (item) {
        var iconItem = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.X_SMALL_CLASS, bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TOOLTIP_CLASS],
            innerText: item.iconTooltip
        });
        iconItem.setAttribute(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TOOLTIP_CLASS, '');
        iconItem.setAttribute(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TOOLTIP_POSITION_TOP, item.positionTooltip);
        iconItem.setAttribute(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TOOLTIP_TEXT, item.textTooltip);
        iconItem.setAttribute(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.ARIA_HIDDEN, true);
        iconItem.setAttribute(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TABINDEX, 0);
        return iconItem;
    };
    BcTransactionConfirmationBehavior.prototype.createItemsSectionData = function (itemsSectionData) {
        var _this = this;
        var sectionDataCardItems = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_ITEMS_CLASS],
        });
        itemsSectionData.forEach(function (item) {
            var sectionDataCardItemNameP = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                innerText: item.name,
                classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.OPENSANS_2_REGULAR]
            });
            var sectionDataCardItemName = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_CARD_ITEMS_ITEM_NAME_CLASS],
                children: [sectionDataCardItemNameP]
            });
            if (item.tooltip) {
                var iconTooltip = _this.createTooltipIcon(item.tooltip);
                sectionDataCardItemName.appendChild(iconTooltip);
            }
            var sectionDataCardItemDesc = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.P_TAG,
                classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_CARD_ITEMS_ITEM_DESC_CLASS],
                innerText: item.desc
            });
            var sectionDataCardItem = (0, helpers_1.createElement)({
                element: common_constants_1.BcCommonConstants.DIV_TAG,
                classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_ITEM_CLASS],
                children: [sectionDataCardItemName, sectionDataCardItemDesc]
            });
            sectionDataCardItems.appendChild(sectionDataCardItem);
        });
        return sectionDataCardItems;
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionConfirmationSectionData = function (itemsSectionData) {
        var sectionDataCardItems = this.createItemsSectionData(itemsSectionData.items);
        var sectionDataCardTitle = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.H4_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_CARD_TITLE_CLASS],
            innerText: itemsSectionData.title
        });
        var sectionDataCard = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: ['bc-card', bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_CARD_CLASS],
            children: [sectionDataCardTitle, sectionDataCardItems]
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_SECTION_DATA_CLASS],
            children: [sectionDataCard]
        });
    };
    BcTransactionConfirmationBehavior.prototype.createHeaderContentAccordionDefault = function (headerContent) {
        var title = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_CONTENT_HEAD_TITLE_LABEL_CLASS],
            innerText: headerContent.name
        });
        var iconTooltip = this.createTooltipIcon(headerContent.tooltip);
        var accordeonDefaultHeadTitle = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_CONTENT_HEAD_TITLE_CLASS],
            children: [title, iconTooltip]
        });
        var accordeonDefaultHeadValue = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.P_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_CONTENT_HEAD_VALUE_CLASS],
            innerText: headerContent.desc
        });
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_CONTENT_HEAD_CLASS],
            children: [accordeonDefaultHeadTitle, accordeonDefaultHeadValue]
        });
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionConfirmationAccordionContent = function (itemsAccordionContent) {
        var accordeonDefaultHead = null;
        if (itemsAccordionContent.isDefault && itemsAccordionContent.itemsAccordeon[0].contentDefault.header) {
            accordeonDefaultHead = this.createHeaderContentAccordionDefault(itemsAccordionContent.itemsAccordeon[0].contentDefault.header);
        }
        var itemsAccordion = this.createItemsSectionData(itemsAccordionContent.itemsAccordeon[0].contentDefault.listItems);
        var accordionContent = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_CONTENT_CLASS],
            children: [itemsAccordion]
        });
        var accordionElements = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_ACCORDION_DEFAULT_CLASS],
            children: [accordionContent]
        });
        if (accordeonDefaultHead) {
            accordionElements.prepend(accordeonDefaultHead);
        }
        return accordionElements;
    };
    BcTransactionConfirmationBehavior.prototype.createTransactionConfirmationLink = function (itemsLink) {
        var linkType = this.linkTypes[itemsLink.type] || this.linkTypes.default;
        var sizeUnderline = this.linkTypes[itemsLink === null || itemsLink === void 0 ? void 0 : itemsLink.sizeUnderline] || bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.LINK_CLASS;
        var sizeIcon = this.iconSize[itemsLink.sizeIcon] || this.iconSize.sm;
        var iconLink = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: ['bc-icon', sizeIcon],
            innerText: itemsLink.icon
        });
        var spanLink = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SPAN_TAG,
            classList: [],
            innerText: itemsLink.text,
        });
        var transactionConfirmationAnchor = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.HREF_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.LINK_CLASS, linkType, sizeUnderline],
            children: [iconLink, spanLink]
        });
        transactionConfirmationAnchor.href = itemsLink.url;
        transactionConfirmationAnchor.target = '_blank';
        return (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_LINK_CLASS],
            children: [transactionConfirmationAnchor]
        });
    };
    BcTransactionConfirmationBehavior.prototype.insertNodeChildrensTransactionConfirmation = function (itemsSettings) {
        var transactionStatusElement = this.createTransactionStatus(itemsSettings.transactionStatus);
        var transactionConfirmationMessageElement = this.createTransactionConfirmationMessage(itemsSettings.transactionConfirmationMessage);
        var transactionConfirmationSectionDataElement = this.createTransactionConfirmationSectionData(itemsSettings.sectionData);
        var transactionConfirmationLinkElement = this.createTransactionConfirmationLink(itemsSettings.link);
        var transactionConfirmationDynamicSpaceElement = this.mySelf.querySelector(".".concat(bc_transaction_confirmation_constants_1.BcTransactionConfirmationConstants.TRANSACTION_CONFIRMATION_DYNAMIC_SPACE)) || transactionConfirmationMessageElement;
        this.mySelf.prepend(transactionStatusElement);
        transactionStatusElement.after(transactionConfirmationMessageElement);
        transactionConfirmationDynamicSpaceElement.after(transactionConfirmationSectionDataElement);
        this.mySelf.append(transactionConfirmationLinkElement);
        bc_tooltip_behavior_1.BcTooltipBehavior.setUpAll();
    };
    return BcTransactionConfirmationBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcTransactionConfirmationBehavior = BcTransactionConfirmationBehavior;
